import moment from "moment-timezone";

export const formatDate = (date, full = false, timeForToday = true) => {
  if (!date) return null;
  if (full)
    return moment.tz(date, "Europe/Paris").format("DD/MM/YYYY HH:mm:ss");
  if (timeForToday && moment.tz(date, "Europe/Paris").isSame(new Date(), "day"))
    return moment(date).format("HH:mm:ss");
  else return moment.tz(date, "Europe/Paris").format("DD/MM/YYYY");
};

export const FormatedDate = ({ date, full = false }) => {
  return formatDate(date, full);
};
